import { Component, OnInit } from '@angular/core';
import { PosFloatingActionButtonService } from 'src/app/@core/services/pos-floating-action-button.service';

@Component({
  selector: 'app-void-payment',
  templateUrl: './void-payment.component.html',
  styleUrls: ['./void-payment.component.sass']
})
export class VoidPaymentComponent implements OnInit {

  constructor(private floatingService: PosFloatingActionButtonService) {
    this.floatingService.setShow(false);
    this.floatingService.addItems();
  }

  ngOnInit(): void {
  }

}
